'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = cart;

var _cart = require('../actions/cart');

var _actions = require('../helpers/actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function cart() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _cart.SET_LINE_ITEM_INPUT:
      return action.lineItemsAsInput;
    case _cart.CLEAR_LINE_ITEM_INPUT:
      return {};
    case 'CART_ADD_MANY_ITEMS':
      return state;
    case 'CART_ADD_MANY_ITEMS_SUCCESS':
      return action.result;
    case 'CART_ADD_MANY_ITEMS_FAILURE':
      return (0, _extends3.default)({}, state, { error: (0, _actions.serializableError)(action.error) });
    default:
      return state;
  }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/reducers/cart.js
// module id = 2526
// module chunks = 0